export const OUTLOOK_SPACES_LOCAL_STORAGE_KEY = 'OutlookSpaces';

export default interface ProjectInLocalStorage {
    pan: { x: number; y: number };
    zoom: number;
    isCanvasLocked: boolean;
    isAssetsLocked: boolean;
}
